import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";

import Typography from "@material-ui/core/Typography";
import StarIcon from "@material-ui/icons/Star";

import { getTireAvailabilityBadge } from "./tireAvailability";
import { formatIls } from "./tirePairModel";

export const BADGE_CLASS = {
  local: "badgeLocal",
  preorder: "badgeOndemand",
  eu: "badgeEu",
  ondemand: "badgeOndemand",
  out: "badgeOut",
};

export function productPath(product) {
  if (!product || !product.ean) {
    return null;
  }

  const slug = encodeURIComponent(product.name || product.displayName || product.ean);
  return `/tire/moto/${product.ean}/${slug}`;
}

export function ScoreMark({ classes, score, className }) {
  if (score == null) {
    return null;
  }

  return (
    <span className={classNames(classes.score, className)}>
      <Typography variant="caption" component="span">
        {`ציון ${score}`}
      </Typography>
      <StarIcon
        className={classes.scoreIcon}
        color="primary"
        fontSize="small"
        aria-hidden="true"
      />
    </span>
  );
}

ScoreMark.propTypes = {
  classes: PropTypes.object.isRequired,
  score: PropTypes.number,
  className: PropTypes.string,
};

export function AvailabilityBadge({ classes, product, badge, className }) {
  const resolved = badge || getTireAvailabilityBadge(product);
  const toneClass = classes[BADGE_CLASS[resolved.kind]] || classes.badgeOut;

  return (
    <span className={classNames(classes.badge, toneClass, className)}>
      <span className={classes.badgeDot} aria-hidden="true" />
      <Typography variant="caption" component="span">
        {resolved.label}
      </Typography>
    </span>
  );
}

AvailabilityBadge.propTypes = {
  classes: PropTypes.object.isRequired,
  product: PropTypes.object,
  badge: PropTypes.shape({
    kind: PropTypes.string,
    label: PropTypes.string,
  }),
  className: PropTypes.string,
};

export function AxleRow({ classes, row }) {
  const body = (
    <React.Fragment>
      {row.label ? (
        <Typography variant="subtitle2" component="span" className={classes.axleLabel}>
          {row.label}
        </Typography>
      ) : null}
      <Typography variant="body2" component="span" className={classes.axleSize}>
        <bdi dir="ltr">{row.size}</bdi>
      </Typography>
      {row.score != null ? (
        <ScoreMark classes={classes} score={row.score} className={classes.rowScore} />
      ) : null}
      {row.showBadge ? (
        <AvailabilityBadge classes={classes} product={row.product} />
      ) : null}
      {row.price != null ? (
        <Typography variant="subtitle2" component="span" className={classes.unitPrice}>
          <bdi dir="ltr">{formatIls(row.price)}</bdi>
        </Typography>
      ) : null}
    </React.Fragment>
  );

  if (!row.href) {
    return <div className={classes.axleRow}>{body}</div>;
  }

  return (
    <Link to={row.href} className={classes.axleRow}>
      {body}
    </Link>
  );
}

AxleRow.propTypes = {
  classes: PropTypes.object.isRequired,
  row: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    size: PropTypes.string,
    product: PropTypes.object,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
    href: PropTypes.string,
    score: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
    showBadge: PropTypes.bool,
  }).isRequired,
};
